import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Tooltip, Typography } from "@mui/material";
import "../Common/css/styles.css";
import AuthLogin from "../Layouts/AuthLogin";
import Card from "../Components/Card";
import text from "../Assets/Text/Text.json";
import { useNavigate } from "react-router";
import { useState } from "react";
import PrimaryInputField from "src/Components/InputFields";
import logo from "../Assets/Images/va_black2.png"
import { AuthBody } from "src/Interfaces/auth";
import CustomAlert from "src/Components/Alerts";
import { initial, login } from "src/Services/auth_api";
import Spinner from "src/Components/Spinner";
import React from "react";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const LoginPage = () => {
  const navigate = useNavigate();

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertDescription, setAlertDescription] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error" | "warning">("success");
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [otp, setOtp] = useState(['', '', '', '']);
  const [copied, setCopied] = React.useState(false);
  const [code, setCode] = useState("");

  const userType = sessionStorage.getItem("userType") || "";

  const showAlert = (description: string, type: "success" | "error" | "warning") => {
    setAlertDescription(description);
    setAlertType(type);
    setAlertOpen(true);
  };

  const handleClose = () => {
    setOpen(false)
    setIsLoading(false)
  }

  const handleClose2 = (_event?: unknown, reason?: string) => {
    handleCopy()
    setOpen2(false);
    navigate("/courses")
    setIsLoading(false)
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  const handleChange = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 3) {
        const next = document.getElementById(`otp-${index + 1}`);
        next?.focus();
      }
    }
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleClose();
    setIsLoading(false)
    handleLogin(otp.join(''))
  };

  const handleLogin = async (otp: string) => {
    if (!username) {
      showAlert("Missing Email", "error");
      return;
    }

    if (!password) {
      showAlert("Missing Password", "error");
      return;
    }

    setIsLoading(true);

    const body: AuthBody = {
      password: password,
      email: username,
      type: "STUDENT",
      providedCode: Number(otp)
    };

    setOtp(["", "", "", ""]);

    try {
      const response = await login(body);
      const data = response.data;


      if (data.type === "Instructor") {
        sessionStorage.setItem("instructorSubjects", JSON.stringify(data.instructorSubjects || []));
        sessionStorage.setItem("userType", "TEACHER");
        sessionStorage.setItem("username", data.name);
        sessionStorage.setItem("token", data.token);
        sessionStorage.setItem("insId", data.id);
        let num = data.id;
        let remainder = num % 4;

        if (remainder === 0) {
          sessionStorage.setItem("houseIns", "GALE");
        } else if (remainder === 1) {
          sessionStorage.setItem("houseIns", "WAVE");
        } else if (remainder === 2) {
          sessionStorage.setItem("houseIns", "STONE");
        } else {
          sessionStorage.setItem("houseIns", "BLAZE");
        }
      }

      setTimeout(() => {
        if (data.type === "Instructor") {
          navigate("/instructor/instructor-dashboard")
          return;
        }
      }, 3000);

      if (data === "You must provide the correct code to log in within 2 minutes of your last session.") {
        setOpen(true);
        return
      }

      setCode(String(data.verificationCode));
      if (data.details) {
        sessionStorage.setItem("subjects", JSON.stringify(data.details.subjects || []));
        sessionStorage.setItem("programme", data.details.programme || "N/A");
        sessionStorage.setItem("stream", data.details.stream || "N/A");
      }

      sessionStorage.setItem("freeCourses", JSON.stringify(data.freeCourses[0] || []));
      sessionStorage.setItem("username", data.fullName);
      sessionStorage.setItem("userId", data.id)
      sessionStorage.setItem("token", data.token);
      sessionStorage.setItem("type", data.type);

      handleInitial(data.token);

      // House Calculation
      let num = data.id;
      let remainder = num % 4;

      if (remainder === 0) {
        sessionStorage.setItem("house", "GALE");
      } else if (remainder === 1) {
        sessionStorage.setItem("house", "WAVE");
      } else if (remainder === 2) {
        sessionStorage.setItem("house", "STONE");
      } else {
        sessionStorage.setItem("house", "BLAZE");
      }

      setTimeout(() => {
        if (data.type === "STUDENT" || data.type === "PARENT") {
          setOpen2(true);
        }
        setIsLoading(false);
      }, 3000);
    } catch (error: any) {
      setTimeout(() => {
        if (error.response?.data?.message === "Invalid credentials") {
          showAlert(error.response.data.message, "error");
        } else if (error.response?.data?.message === "Inactive user") {
          showAlert("Your account is banned. Please contact support.", "error");
        } else {
          showAlert("Login failed. Please try again.", "error");
        }
        setIsLoading(false);
      }, 3000);
    }
  };

  const handleInitial = async (token: any) => {
    try {
      const res = await initial(token);
      sessionStorage.setItem("expireDate", res.data.paymentStatus.paymentExpirationDate || "");
      sessionStorage.setItem("dueAmount", res.data.paymentStatus.dueAmount || "0.00");
      sessionStorage.setItem("dueInstallments", res.data.paymentStatus.dueInstallments || "0");
      sessionStorage.setItem("totalAmount", res.data.paymentStatus.totalAmount || "");
      sessionStorage.setItem("gender", res.data.gender || "");
      sessionStorage.setItem("spg", res.data.performance.gpa || "");
      sessionStorage.setItem("badge", res.data.performance.badge || "");
    } catch (error) {
      console.error(error);
    }
  }

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    const paste = event.clipboardData.getData('text');
    if (/^\d{4}$/.test(paste)) {
      event.preventDefault(); // Prevent the default paste
      const newOtp = paste.split('');
      setOtp(newOtp);

      // Focus last field
      const last = document.getElementById(`otp-3`);
      last?.focus();
    }
  };

  return (
    <AuthLogin>
      <Card>
        <div className="login-main-outer">
          <CustomAlert
            open={alertOpen}
            onClose={() => setAlertOpen(false)}
            description={alertDescription}
            type={alertType}
            timeout={3000}
          />
          <Spinner isLoading={isLoading} />
          <Dialog open={open} onClose={handleClose}>
            <form onSubmit={handleSubmit}>
              <DialogTitle sx={{ backgroundColor: '#121212', color: '#fff', textAlign: "center" }}>
                {text.loginPage.accLockText}
                <br />
                {text.loginPage.accLockText2}
              </DialogTitle>
              <DialogContent sx={{ backgroundColor: '#1e1e1e', color: '#fff' }}>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 1 }}>
                  {otp.map((digit, index) => (
                    <TextField
                      key={index}
                      id={`otp-${index}`}
                      value={digit}
                      onChange={handleChange(index)}
                      onPaste={index === 0 ? handlePaste : undefined}
                      inputProps={{
                        maxLength: 1,
                        style: {
                          textAlign: 'center',
                          fontSize: '1.5rem',
                          width: '2rem',
                          height: '2rem',
                          color: '#fff',
                          backgroundColor: '#333',
                          borderRadius: '4px',
                        },
                      }}
                      variant="outlined"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: '#555',
                          },
                          '&:hover fieldset': {
                            borderColor: '#888',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#aaa',
                          },
                        },
                      }}
                    />
                  ))}
                </Box>
              </DialogContent>
              <DialogActions sx={{ backgroundColor: '#121212', color: '#fff' }}>
                <Button onClick={handleClose} sx={{ color: '#bbb' }}>
                  {text.navigation.cancel}
                </Button>
                <Button
                  type="submit"
                  disabled={otp.some((d) => d === '')}
                  sx={{
                    color: '#fff',
                    backgroundColor: '#333',
                    '&:hover': {
                      backgroundColor: '#444',
                    },
                  }}
                >
                  {text.loginPage.submitButton}
                </Button>
              </DialogActions>
            </form>
          </Dialog>
          <Dialog open={open2}>
            <DialogTitle sx={{ backgroundColor: '#121212', color: '#fff', textAlign: "center" }}>{text.loginPage.copyCodeText}</DialogTitle>
            <DialogContent sx={{ backgroundColor: '#121212', color: '#fff', textAlign: "center" }}>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {text.loginPage.immediateLoginText}
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mt: 1 }}>
                <Typography variant="h4" component="span">
                  {code}
                </Typography>
                <Tooltip title={copied ? "Copied!" : "Copy to clipboard"}>
                  <IconButton onClick={handleCopy}>
                    <ContentCopyIcon style={{ color: "white" }} />
                  </IconButton>
                </Tooltip>
              </Box>
            </DialogContent>
            <DialogActions sx={{ backgroundColor: '#121212', color: '#fff', textAlign: "center" }}>
              <Button sx={{ color: '#bbb' }} onClick={handleClose2}>{text.loginPage.loginButton}</Button>
            </DialogActions>
          </Dialog>
          <div className="login-head">
            <span style={{ fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif" }}>{userType === "STUDENT" ? text.loginPage.loginHeading2 : userType === "PARENT" ? text.loginPage.loginHeading3 : text.loginPage.loginHeading4} </span>
          </div>

          <hr style={{ margin: "10px 0 20px 0" }} />
          <div className="login-head-outer-main">
            <img className="content-logo" src={logo} alt="" />
          </div>
          <div className="space"></div>
          <div className="login-head-outer-main mt">
            <PrimaryInputField
              placeholder="Enter your email"
              helperText={text.loginPage.usernameLabel}
              value={username}
              type="text"
              disabled={false}
              width="400ch"
              size="small"
              onChange={(e: any) => setUsername(e.target.value)}
            />
          </div>
          <div className="login-head-outer-main">
            <PrimaryInputField
              placeholder="Enter your password"
              helperText={text.loginPage.passwordLabel}
              value={password}
              type="password"
              disabled={false}
              width="400ch"
              size="small"
              onChange={(e: any) => setPassword(e.target.value)}
            />
          </div>
          <div className="login-head-outer1">
          </div>
          <div className="login-head-outer2">
            <Button className="login-btn" variant="contained" onClick={(e: any) => handleLogin("")}>
              {text.loginPage.loginButton}
            </Button>
          </div>
        </div>
      </Card>
    </AuthLogin>
  );
};

export default LoginPage;
